import React from 'react';
import './App.css';
import About from './components/about/about';
import Resume from './components/resume/resume';
import Portfolio from './components/portfolio/portfolio';
import Footer from './components/footer/footer';

// Data for components
import resumeData from './data/resumeData';
import aboutData from './data/aboutData';
import portfolioData from './data/portfolioData';
function App() {
  return (
    <div className="App">
        <About aboutData = {aboutData} resumeData={resumeData}/>
        <Resume resumeData={resumeData} />
        {/* <Portfolio portfolioData={portfolioData} /> */}
        <Footer  />
    </div>
  );
}

export default App;
